// React imports
import React from "react";
import { Routes, Route } from "react-router-dom";

// Component imports
import DealsLayout from "./DealsLayout_Component";
import Dashboard from "./Dashboard_Component";
import ComingSoonPage from "./ComingSoonPage_Component";
import AdminLayout from "./components/admin/AdminLayout";
import AdminRoute from "./components/admin/AdminRoute";
import UploadPage from "./UploadPage_Component";
import DraftEditor from "./DraftEditor_Component";

// Default export of MainContentArea_Component
export default function MainContentArea_Component(): JSX.Element {

  return (
    // Main content area container - responsive padding and mobile optimizations
    <div className="h-full overflow-y-auto bg-transparent px-3 sm:px-4 md:px-6 tablet:px-0 py-3 sm:py-4 tablet:py-0">
      <Routes>
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/draft" element={<DraftEditor />} />
        <Route path="/admin/*" element={
          <AdminRoute>
            <AdminLayout />
          </AdminRoute>
        } />
        <Route path="/*" element={<DealsLayout />} />
      </Routes>
    </div>
  );
}

// {isDashboardRoute && (
//         // Dashboard component occupies full available space within MainContentArea
//         <Dashboard />
//       )}

//       {/* Fallback for unknown routes - render ComingSoonPage */}
//       {!isDealsRoute && !isDashboardRoute && (
//         // ComingSoonPage component rendered for any other route
//         <ComingSoonPage />
//       )}
